import { createApp } from 'vue';
import App from './app/App.vue';
import routes from './app/routes';
import { createRouter, createWebHashHistory } from "vue-router";
import { createPinia } from "pinia";

const pinia = createPinia()

const router = createRouter({
    history: createWebHashHistory(),
    routes: routes
})

const app = createApp(App);

app.use(router);
app.use(pinia);
app.mount("#js-timeline-map");